


























import Vue, { PropType } from 'vue';
import CardLayout from '@/components/card-layout/CardLayout.vue';
import { DreesContacts, HomeSummary } from '@/types';
import { getInitials } from '@/util';
import { getCustomerCareRepData } from '@/api';

export default Vue.extend({
  name: 'CustomerCare',
  components: {
    CardLayout
  },
  props: {
    dreesContacts: {
      type: Array as PropType<DreesContacts[]>,
      required: true
    },
    postClose: {
      type: Boolean,
      required: true
    },
    homeDetail: {
      type: Object as PropType<HomeSummary>,
      required: true
    }
  },
  data () {
    return {
      customerCareContact: {} as DreesContacts
    }
  },
  async mounted () {
    const empId = this.homeDetail?.customerCare?.customerCareRepEmpId;
    if (empId) {
      this.customerCareContact = await this.fetchCustomerCareRepresentative(empId);
    }
  },
  watch: {
    async homeDetail (newValue: HomeSummary) {
      const empId = newValue?.customerCare?.customerCareRepEmpId;
      if (this.postClose && empId) {
        this.customerCareContact = await this.fetchCustomerCareRepresentative(empId);
      }
    }
  },
  methods: {
    fetchInitials (firstName: string, lastName: string) {
      return getInitials(firstName, lastName);
    },
    async fetchCustomerCareRepresentative (ccRepId: string) {
      if (ccRepId) {
        const teamMemberData = await getCustomerCareRepData(ccRepId);
        return teamMemberData.customerCareMember;
      } else {
        return {} as DreesContacts;
      }
    }
  }
})
